import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import * as styles from "../styles.module.scss";
const useWheelOverlay = (text, classes) => {
    const [showWheelOverlay, setShowWheelOverlay] = useState(false);
    const handlePlotWrapperWheel = useCallback((e) => {
        const { ctrlKey } = e;
        if (!ctrlKey) {
            setShowWheelOverlay(true);
            e.stopPropagation();
        }
        else {
            setShowWheelOverlay(false);
        }
    }, []);
    useEffect(() => {
        const timer = setTimeout(() => {
            showWheelOverlay && setShowWheelOverlay(false);
        }, 1000);
        return () => {
            clearTimeout(timer);
        };
    }, [showWheelOverlay]);
    const renderWheelOverlay = useMemo(() => (React.createElement("div", { className: classNames(styles.overlay, classes?.root, {
            [styles.visible]: showWheelOverlay,
        }) },
        React.createElement("p", { className: classNames(styles["overlay-text"], classes?.text) },
            "Use Ctrl + Scroll to zoom the ",
            text))), [showWheelOverlay, text, classes]);
    return { renderWheelOverlay, handlePlotWrapperWheel };
};
export default useWheelOverlay;
